<template>
  <ul class="photo-gallery-box">
    <li v-for="(item, index) in list" :key="index" class="photo-gallery-item">
      <PhotoGalleryItem :photo="item" />
    </li>
  </ul>

</template>

<script>
  import PhotoGalleryItem from '@/components/PhotoGalleryItem'

  export default {
    components: { PhotoGalleryItem },
    props: {
      list: {
        type: Array,
        default: []
      }
    }

  }
</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";

  .photo-gallery-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 10px 0 40px 0;
    .photo-gallery-item:not(:last-child) {
      padding-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PhotoGallery.vue